export default __webpack_public_path__ + "static/media/pixels-project-5.ecb40816.jpg";